import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { priceService } from '../../services/priceService';
import DietPricesPanel from '../../components/Setup/DietPricesPanel';
import Button from '../../components/UI/Button';
import LoadingSpinner from '../../components/UI/LoadingSpinner';

const PriceDietPricingPage: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  const { data, isLoading } = useQuery({
    queryKey: ['price', id],
    enabled: !!id,
    queryFn: () => priceService.getPrice(id as string),
  });

  if (!id) return null;

  const price = (data as any)?.price;

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">Manage Diet Pricing</h1>
          {isLoading ? (
            <div className="mt-2"><LoadingSpinner size="sm" /></div>
          ) : (
            <p className="text-gray-600 mt-1">
              <span className="font-medium">Price:</span> {price?.name} {price?.type ? <span className="ml-2 text-gray-500">({price.type})</span> : null}
            </p>
          )}
        </div>
        <div className="flex gap-3">
          <Button variant="secondary" onClick={() => navigate(-1)}>Back</Button>
        </div>
      </div>

      {/* Diet Pricing grid for this specific Price */}
      <DietPricesPanel initialPriceId={id} hidePriceSelector />
    </div>
  );
};

export default PriceDietPricingPage;

